<template>
  <div class="find">
    <!-- <back :title="title" /> -->
    <div>
      <div class="search" @touchmove.stop.prevent="">
        <div class="search-head">
          <div
            class="searchInput"
            @click="
              () => {
                this.$router.push('/search')
              }
            "
          >
            <input disabled="true" type="text" placeholder="请输入名称搜索" placeholder-style="color:#C0C4CC" />
            <img src="../../assets/image/content_icon_search2x.png" />
          </div>
          <div class="search-hot">
            <div @click="orderTypeShow = true">
              {{ orderTypeTxt }}
              <img style="width: 12px; height: 6px" src="../../assets/image/content_icon_dropdown2x.png" />
            </div>
          </div>
        </div>
        <ul class="subject-list">
          <li :class="{active: subjectId == -1}" @click="handleChangeSubject(-1)">全部</li>
          <li
            :class="{active: subjectId == subject.id}"
            v-for="subject in subjectList"
            :key="subject.id"
            @click="handleChangeSubject(subject.id)"
          >
            {{ subject.name }}
          </li>
        </ul>
      </div>
      <div v-show="isShow !== -1" class="model" @touchmove.stop.prevent="" @click="isShow = -1">
        <div v-show="isShow === 1">
          <div
            v-for="(item, index) in hotList"
            :key="item"
            :class="index === hotIndex ? 'act box-w' : 'box-w'"
            @click.stop="hotFun(index)"
          >
            <p>{{ item }}</p>
            <img v-if="hotIndex === index" src="../../assets/image/content_icon_select2x.png" />
          </div>
        </div>
        <div v-show="isShow === 2">
          <div class="box-w" @click="empty">
            <p style="text-align: right; width: 100%" :class="screenType === 0 ? 'act' : ''">全部</p>
          </div>
          <div
            class="box-w"
            @click="
              () => {
                this.$router.push('/find/subject')
              }
            "
          >
            <p style="text-align: right; width: 100%" :class="screenType === 1 ? 'act' : ''">学科筛选</p>
          </div>
          <div
            class="box-w"
            @click="
              () => {
                this.$router.push('/find/label?type=1')
              }
            "
          >
            <p style="text-align: right; width: 100%" :class="screenType === 2 ? 'act' : ''">标签筛选</p>
          </div>
        </div>
      </div>

      <template v-if="List.length > 0 && !emptyFlag">
        <van-list
          :immediate-check="false"
          class="main-content"
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoadFun2"
        >
          <box v-for="item in List" :key="item.id" :online="item" />
        </van-list>
      </template>
      <template v-if="List.length <= 0 && emptyFlag">
        <empty-component />
      </template>
    </div>
    <van-action-sheet v-model="orderTypeShow" :actions="orderList" @select="onSelectOorderType" />
  </div>
</template>

<script>
// import Back from '@/components/back'
import {subjectByGrade} from '@/api/dd'
import {getFindInfo} from '@/api/index'
export default {
  name: 'find',
  components: {
    box: () => import('./box')
    // back: Back
  },
  data() {
    return {
      loading: false,
      finished: false,
      title: '',
      screenType: 0, // 0全部 1学科 2 标签
      actList: [
        {
          id: 1,
          value: '录播'
        },
        {
          id: 2,
          value: '同步课'
        },
        {
          id: 5,
          value: '教研'
        },
        {
          id: 6,
          value: '直播'
        },
        {
          id: 3,
          value: '会议'
        }
      ],
      isShow: -1, // 1最*排序 2筛选
      hotList: ['最新', '最热', '最赞'],
      hotIndex: 0,
      screenIndex: -1,
      Width: 32,
      emptyFlag: null,
      List: [],
      pageNo: 1,
      pageSize: 20,
      resourceFamily: 0, // 分类（0:全部,1：录播预约，2：同步课堂，3：视频会议，4：直播教研，5：互动教研，6：直播，7;活动化直播）
      stageId: -1, // 阶段ID（基础信息接口获取）
      gradeId: -1, // 年级ID（基础信息接口获取）
      subjectId: -1, // 科目ID（基础信息接口获取）
      versionId: -1, // 版本ID（基础信息接口获取）
      catalogId: -1, // 目录id（基础信息接口获取）
      lableId: -1, // 标签ID （标签信息接口获取）
      queryType: 1, // 筛选方式(1科目,2标签,默认值：1)
      defaultImgUrl: 'http://ysclass.net/a/default/default-wx-1.png',
      leftIndex1: 0,
      rightIndex1: -1,
      totalPages: 0,
      debounce: true,

      subjectList: [],
      orderType: 1,
      orderTypeTxt: '最新',
      orderTypeShow: false,
      orderList: [
        {name: '最新', value: 1, color: '#4465F3'},
        {name: '最热', value: 2, color: '#323233'},
        {name: '最赞', value: 3, color: '#323233'}
      ]
    }
  },
  methods: {
    isLabel() {
      const label = window.sessionStorage.getItem('label') ? JSON.parse(window.sessionStorage.getItem('label')) : null
      if (label) {
        this.lableId = label.lableId
        this.queryType = label.queryType
      }
    },
    isSubject() {
      const subject = window.sessionStorage.getItem('subject')
        ? JSON.parse(window.sessionStorage.getItem('subject'))
        : null
      if (subject) {
        this.stageId = subject.stageId
        this.gradeId = subject.gradeId
        this.subjectId = subject.subjectId
        this.versionId = subject.versionId
        this.catalogId = subject.catalogId
        this.queryType = subject.queryType
      }
    },
    convertTime(time) {
      const t = new Date(time)
      const Y = t.getFullYear()
      const M = t.getMonth() + 1
      const D = t.getDate()
      return Y + '-' + M + '-' + D
    },
    empty() {
      this.screenType = 0
      this.stageId = -1
      this.gradeId = -1
      this.subjectId = -1
      this.versionId = -1
      this.catalogId = -1
      this.lableId = -1
      this.queryType = 1
      this.List = []
      this.emptyFlag = null
      this.pageNo = 1
      this.leftIndex1 = 0
      this.rightIndex1 = -1
      this.onLoadFun2()
    },
    onSelectOorderType(info) {
      this.orderList.forEach(item => {
        item.color = '#323233'
      })
      info.color = '#4465F3'
      this.orderTypeTxt = info.name
      this.orderType = info.value
      this.orderTypeShow = false
      this.finished = false
      this.pageNo = 1
      this.hotIndex = info.value - 1
      this.List = []
      this.onLoadFun2()
    },
    onLoadFun2() {
      const data = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        orderType: this.hotIndex + 1,
        resourceFamily: this.resourceFamily,
        stageId: this.stageId,
        gradeId: this.gradeId,
        subjectId: this.subjectId,
        versionId: this.versionId,
        catalogId: this.catalogId,
        lableId: this.lableId,
        queryType: this.queryType
      }
      getFindInfo(data)
        .then(res => {
          if (res.code === 0 && res.success) {
            const data = res.data
            if (data.length === 0) {
              this.List = []
              this.emptyFlag = true
              return false
            }
            data.forEach(item => {
              if (item.createTime > new Date().getTime()) {
                item.nostart = true
              } else {
                item.nostart = false
              }
              item.createTimeFormate = this.convertTime(item.createTime)
              item.pic = item.pic === null || item.pic === '' ? this.defaultImgUrl : item.pic
            })
            this.pageNo += 1
            this.totalPages = Math.ceil(Number(res.totalDatas) / this.pageSize)
            this.emptyFlag = false
            this.List = this.List.concat(data)
          }
        })
        .catch(() => {
          // console.log("err", err);
        })
    },
    hotFun(i) {
      this.hotIndex = i
      this.pageNo = 1
      this.List = []
      this.emptyFlag = null
      this.onLoadFun2()
    },
    imageLoaded(ref) {
      // 设置超时，确保图片渲染完成
      setTimeout(() => {
        this.$refs[ref][0].calculateLayout()
      }, 100)
    },
    getWaterfallItemWidth(e) {
      this.Width = e
    },
    waterfallClick(i) {
      if (this.List[i].type === 2 || this.List[i].type === 3) {
        const random = Math.floor(Math.random() * 10)
        if (random <= this.$watchDetail) {
          this.$router.push('/detail/play/' + this.List[i].id)
        } else {
          this.$router.push('/alipay/play/' + this.List[i].id)
        }
      } else if (this.List[i].type === 1) {
        this.$router.push('/find/resource/' + this.List[i].id)
      }
    },
    getScroll() {
      return {
        left: window.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft || 0,
        top: window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0
      }
    },
    scroll() {
      const body = document.documentElement || document.body
      const scrollTop = this.getScroll().top
      if (body.clientHeight + scrollTop >= body.scrollHeight - 30) {
        if (this.pageNo <= this.totalPages) {
          if (this.debounce) {
            this.debounce = false
            this.onLoadFun2()
            setTimeout(() => {
              this.debounce = true
            }, 1000)
          }
        }
      }
    },
    getAllSubject() {
      const params = {
        subjectType: '378953758199259136',
        periodId: this.$route.params.id
      }
      this.subjectList = []
      subjectByGrade(params).then(res => {
        console.log('res', res)
        this.subjectList = res.data
      })
    },
    handleChangeSubject(id) {
      this.subjectId = id
      this.pageNo = 1
      this.List = []
      this.emptyFlag = null
      this.onLoadFun2()
    }
  },
  created() {
    // this.subjectId = this.$route.query.subjectId;
    // let subjectName = this.$route.query.subjectName;
    // document.title = subjectName;
    this.title = this.$route.query.title
    this.stageId = this.$route.params.id
  },
  mounted() {
    this.getAllSubject()
    this.isSubject()
    this.isLabel()
    this.onLoadFun2()
    window.addEventListener('scroll', this.scroll, false)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.scroll)
    window.sessionStorage.removeItem('subject')
    window.sessionStorage.removeItem('label')
  }
}
</script>

<style lang="scss" scoped>
.search {
  width: 100%;
  padding: 0 16px;
  box-sizing: border-box;
  z-index: 2;
  .search-head {
    margin-top: 6px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }
  .subject-list {
    margin-top: 20px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    li {
      margin-right: 36px;
      margin-bottom: 20px;
      font-size: 14px;
      color: #606266;
      &.active {
        font-weight: 700;
        color: #4465f3;
      }
    }
  }
  .searchInput {
    width: 80%;
    height: 36px;
    background: #fff;
    padding: 0 12px;
    border-radius: 18px;
    box-sizing: border-box;
    input {
      width: 90%;
      font-size: 14px;
      height: 36px;
      line-height: 36px;
      background: #fff;
      box-sizing: border-box;
      border: none;
      float: left;
    }
    img {
      width: 15px;
      height: 15px;
      float: right;
      margin-top: 11px;
    }
  }
  .search-hot {
    div {
      color: #303133;
      height: 25px;
      font-size: 15px;
      display: flex;
      align-items: center;
      img {
        margin-left: 7.5px;
      }
    }
  }
  .hotAndScreen {
    width: 100%;
    height: 25px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 16px;
    /* div {
      color: #303133;
      height: 25px;
      font-size: 15px;
      display: flex;
      align-items: center;
      img {
        margin-left: 7.5px;
      }
    } */
  }
  .scroll-view_H {
    width: 100%;
    height: 30px;
    white-space: nowrap;
    padding-top: 15px;
    div {
      display: inline-block;
      line-height: 28px;
      padding: 0 15px;
      margin-right: 12px;
      color: #303133;
      font-size: 13px;
      background: #fff;
      border: 1px solid #e5e8ec;
      border-radius: 14px;
      box-sizing: border-box;
    }
  }
}
.model {
  width: 100%;
  height: calc(100%);
  background: rgba(0, 5, 26, 0.4);
  position: absolute;
  top: 50px;
  z-index: 1;
  .box-w {
    margin-top: -1px;
    width: 100%;
    height: 40px;
    background: #f4f6f9;
    padding: 3px 16px 10px 16px;
    line-height: 30px;
    box-sizing: border-box;
    color: #303133;
    font-size: 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    img {
      width: 14px;
      height: 10px;
    }
  }
  .act {
    color: #4465f3;
  }
}
.waterfall {
  background: #ffffff;
  border-radius: 3px;
  margin-bottom: 10px;
  padding-bottom: 10px;
  overflow: hidden;
  > p:nth-child(2) {
    color: #303133;
    width: 100%;
    padding: 8px 8px 0 8px;
    font-size: 14px;
    box-sizing: border-box;
    line-height: 17.5px;
    font-weight: 500;
  }
  > p:nth-child(3) {
    color: #909399;
    width: 100%;
    font-size: 12px;
    padding: 7.5px;
    box-sizing: border-box;
  }
  div {
    width: 100%;
    padding: 0 7.5px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    color: #909399;
    font-size: 12px;
  }
}
.main-content {
  margin-top: 20px;
  padding: 0 16px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  background: #f4f6f9;
}
</style>
<style lang="scss">
.main-content {
  .van-list__loading,
  .van-list__finished-text {
    width: 100%;
  }
}
</style>
